import api from './api';

const extractData = (data) => {
  if (data && typeof data === 'object' && data.$values) {
    return data.$values;
  }
  return data;
};

const placeServicePaymentProfessionalsService = {
  // Listar preços customizados de um profissional para um serviço+local
  // Rota: GET /api/place-service-payment-professionals?placeServiceProfessionalId={id}
  getByPlaceServiceProfessional: async (placeServiceProfessionalId) => {
    const response = await api.get('/place-service-payment-professionals', {
      params: { placeServiceProfessionalId },
    });
    return extractData(response.data);
  },

  // Criar preço customizado
  // Rota: POST /api/place-service-payment-professionals
  // Body: { placeServiceProfessionalId, placeServicePaymentId, customPrice }
  create: async (data) => {
    const response = await api.post('/place-service-payment-professionals', data);
    return response.data;
  },

  // Atualizar preço customizado
  // Rota: PUT /api/place-service-payment-professionals/{id}
  // Body: { customPrice }
  update: async (id, data) => {
    const response = await api.put(`/place-service-payment-professionals/${id}`, data);
    return response.data;
  },

  // Deletar preço customizado (soft-delete)
  // Rota: DELETE /api/place-service-payment-professionals/{id}
  delete: async (id) => {
    await api.delete(`/place-service-payment-professionals/${id}`);
  },
};

export default placeServicePaymentProfessionalsService;
